import ButtonCellSubtitle from "./ButtonCellSubtitle";
import createFabric from "../../../../../fabrics/createFabric";

export default createFabric("Subtitle", ButtonCellSubtitle);
